import React from 'react'
import { render } from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { Router, Route, browserHistory } from 'react-router'
import { Provider } from 'react-redux'
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
import reducer from './Reducers'
import ContainerApp from './Containers/ContainerApp'
import ContainerAdmin from './Containers/ContainerAdmin'
import firebase from 'firebase'
// import registerServiceWorker from './registerServiceWorker'
import './Components/styles/Common.css'

// registerServiceWorker()

firebase.initializeApp({
  apiKey: "AIzaSyCyA4arI_nimmuCzpSACJfnJ-WqZvWbJl0",
  authDomain: "anhilmarin2017.firebaseapp.com",
  databaseURL: "https://anhilmarin2017.firebaseio.com",
  projectId: "anhilmarin2017",
  storageBucket: "anhilmarin2017.appspot.com",
  messagingSenderId: "915902944357"
})

const middleware = [thunk]
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger())
}

const store = createStore(
  reducer,
  applyMiddleware(...middleware)
)

render(
  <Provider store={store}>
    <Router history={browserHistory}>
        <Route path="/" component={ContainerApp} />
        <Route path="/admin" component={ContainerAdmin} />
        <Route path="/admin/:adminPage" component={ContainerAdmin} />
        <Route path="/admin/:adminPage/:object" component={ContainerAdmin} />
    </Router>
  </Provider>,
  document.getElementById('root') 
)








// WEBPACK FOOTER //
// ./src/index.js